// /*
//    Author: Bhavya
//        &&: Piyush Dubey
// */

// import React from "react";
// import history from "helper/history";
// import Recaptcha from "react-google-recaptcha";

// import Layout from "./layout";
// import {
//     CustomPrimaryButton as SaveButton,
//     CustomSecondaryButton as CancelButton,
//     InputElement
// } from "../../customComponents/components";

// import LoginStore from "../../stores/loginstore";
// import * as LoginAction from "../../actions/loginaction";
// import i18n from "../../i18nNext";

// let txtStyle = {
//     borderRadius: 2,
//     backgroundColor: "#f9fafc",
//     border: "solid 2px #eef2f7",
//     fontSize: 14,
//     height: 36
// };
// export default class MobileVerificationPage extends React.Component {
//     constructor() {
//         super();
//         this.state = {
//             otp: "",
//             mobile: LoginStore._getField("user"),
//             OTPSent: LoginStore._getField("otp"),
//             checkString: "",
//             countryCode: LoginStore._getField("c_code"),
//             sitekey: this._checksiteKey(),
//             response: "",
//             otpResendlabel: false,
//             showOtpTab: false
//         };
//         this.recaptchaInstance = "";
//         this._otpRecieve = this._otpRecieve.bind(this);
//         this._resendOTP = this._resendOTP.bind(this);
//         this._handleSubmit = this._handleSubmit.bind(this);
//         this._fieldOnChange = this._fieldOnChange.bind(this);
//     }

//     componentDidMount() {
//         LoginStore.on("change", this._otpRecieve);
//     }

//     componentWillUnmount() {
//         LoginStore.removeListener("change", this._otpRecieve);
//     }

//     _otpRecieve() {
//         let { response } = this.state;
//         this.setState({
//             OTPSent: LoginStore._getField("otp"),
//             otp: "",
//             showOtpTab: response ? true : false
//         });
//     }

//     _handleSubmit(event) {
//         event.preventDefault();
//         let profiles = LoginStore._getField("profiles");

//         if (!this.state.OTPSent) {
//             this._resendOTP(LoginStore._getField("user"));
//         } else {
//             if (!this.state.otp.trim()) {
//                 LoginAction.setAnyKey("errorMsg", i18n.t("err.otpYouReceived"));
//             } else {
//                 let data = {
//                     user: this.state.mobile,
//                     otp: this.state.otp,
//                     mobile_extension: LoginStore._getField("c_code")
//                 };
//                 if (LoginStore._getField("userId")) {
//                     data.user_id = LoginStore._getField("userId");
//                 }
//                 LoginAction.loginApi(data, true);
//             }
//         }
//     }

//     _resendOTP(mobileNo) {
//         let { response, mobile } = this.state;
//         let pattern = /[0-9]/g;
//         let mobileEmailVariable = mobileNo || mobile;
//         let mob = {};
//         let code = LoginStore._getField("mobileExt");
//         let countryCode = LoginStore._getField("c_code");
//         if (mobileEmailVariable.length == 10) {
//             if (mobileEmailVariable.match(pattern)) {
//                 this.setState({ checkString: "Mobile Number" });
//                 mob.mobile_number = mobileNo || mobile;
//                 mob.mobile_extension = countryCode || code;
//             }
//         } else {
//             this.setState({ checkString: "Email Id" });
//             mob.email_id = mobileNo || mobile;
//         }
//         if (response === "") {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.kindlyValidateRecaptcha"));
//             return false;
//         } else {
//             mob.response = response;
//         }
//         LoginAction.sendOTPApi(mob);
//     }

//     _fieldOnChange(event, value) {
//         event.preventDefault();
//         if (isNaN(value)) return false;
//         this.setState({ otp: value });
//     }
//     _checksiteKey() {
//         let origin = window.location.origin;

//         if (
//             [
//                 "http://localhost:8080",
//                 "https://v2-uat.happay.in",
//                 "https://expense-uat.happay.in",
//                 "file://",
//                 "https://dc0hc3otlytmh.cloudfront.net",
//                 "http://3.210.31.248:8005",
//                 "https://expense-prep.happay.in"
//             ].indexOf(origin) !== -1
//         ) {
//             return "6LdL7T8UAAAAAMxVRrPW8hqpAHWMtRCE2TSDSfuO";
//         } else if (origin == "https://expense.happay.in") {
//             return "6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL";
//         } else {
//             return "6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL";
//         }
//     }
//     onChangeCaptcha(value) {
//         this.setState({
//             response: value
//         });
//     }
//     onBackClick() {
//         this.setState({
//             response: "",
//             otpResendlabel: true
//         });
//     }

//     _renderInputField() {
//         const { otp, OTPSent, response, showOtpTab } = this.state;
//         return (
//             <div className="loginContainer">
//                 {OTPSent && response && showOtpTab ? (
//                     <div>
//                         <div
//                             className="mobileLabel"
//                             style={{ width: "100%", margin: "21px 0 10px 0" }}
//                         >
//                             {" "}
//                             {i18n.t("lbl.OneTimePasswordOtp")}
//                         </div>
//                         <InputElement
//                             type="text"
//                             style={{ ...txtStyle, ...{ width: "100%" } }}
//                             className="inputElement"
//                             placeholder={i18n.t("lbl.enterOTP")}
//                             value={otp}
//                             onChange={this._fieldOnChange}
//                             autoFocus={true}
//                         />
//                         <div className="buttonContainer">
//                             <div style={{ textAlign: "left", width: "45%", marginRight: "5%" }}>
//                                 <CancelButton
//                                     label={i18n.t("btn.back")}
//                                     className="nextButton"
//                                     style={{ width: "100%", margin: "0" }}
//                                     onClick={this.onBackClick.bind(this)}
//                                 />
//                             </div>
//                             <div style={{ textAlign: "right", width: "45%", marginLeft: "5%" }}>
//                                 <SaveButton
//                                     label={i18n.t("btn.signIn")}
//                                     className="nextButton"
//                                     style={{ width: "100%", margin: "0" }}
//                                     type="submit"
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 ) : (
//                     <div>
//                         <div className="captcha-section" style={{ marginTop: 20 }}>
//                             <Recaptcha
//                                 ref={e => (this.recaptchaInstance = e)}
//                                 className="g-recaptcha"
//                                 sitekey={this.state.sitekey}
//                                 onChange={this.onChangeCaptcha.bind(this)}
//                             />
//                         </div>
//                         <div className="buttonContainer">
//                             <div style={{ textAlign: "left", width: "42%", marginRight: "4%" }}>
//                                 <CancelButton
//                                     label={i18n.t("btn.back")}
//                                     className="nextButton"
//                                     style={{ width: "100%", margin: "0" }}
//                                     onClick={() => {
//                                         history.goBack();
//                                     }}
//                                 />
//                             </div>
//                             <div style={{ textAlign: "right", width: "42%", marginLeft: "4%" }}>
//                                 <SaveButton
//                                     label={
//                                         this.state.otpResendlabel
//                                             ? `${i18n.t("btn.resendOtp")}`
//                                             : `${i18n.t("btn.getOtp")}`
//                                     }
//                                     className="nextButton"
//                                     style={{ width: "100%", margin: "0" }}
//                                     onClick={this._resendOTP.bind(this, this.state.mobile)}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );
//     }

//     render() {
//         return (
//             <div>
//                 <Layout
//                     subHeader={
//                         this.state.OTPSent && this.state.response && this.state.showOtpTab
//                             ? "otp"
//                             : "reCaptcha"
//                     }
//                     selectedTab={type => this._selectTab(type)}
//                 />
//                 <form onSubmit={this._handleSubmit} autoComplete="off">
//                     {this._renderInputField()}
//                 </form>
//             </div>
//         );
//     }
// }

//---------------- Start External Library Import --------------------//
import React from "react";
import SigninPreOTPPage from "@techsoftware/happay-widgets/SignInPreOTPPage";
import SigninPostOTPPage from "@techsoftware/happay-widgets/SignInPostOTPPage";
import history from "helper/history";
import Recaptcha from "react-google-recaptcha";
//---------------- End External Library Import --------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Stores Dependency Import -------------------------------------//
import LoginStore from "../../stores/loginstore";
//------------------- End Stores Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
//------------------- End Helpers Dependency Import -------------------------------------//

import Common from "../../constants/common";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";

export default class MobileVerificationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: LoginStore._getField("c_code"),
            user: LoginStore._getField("user"),
            activeTab: LoginStore._getField("activeTab"),
            sitekey: this._checksiteKey(),
            response: "",
            showOtpTab: false,
            OTPSent: LoginStore._getField("otp"),
            userId: LoginStore._getField("userId")
        };
        this.recaptchaInstance = "";
        this._otpRecieve = this._otpRecieve.bind(this);
    }
    componentDidMount() {
        LoginStore.on("change", this._otpRecieve);
    }
    componentWillUnmount() {
        LoginStore.removeListener("change", this._otpRecieve);
        LoginStore._setField("otp", "");
    }
    _checksiteKey() {
        let origin = window.location.origin;

        if (
            [
                "http://localhost:8080",
                "https://v2-uat.happay.in",
                "https://expense.uat.happay.in",
                "file://",
                "https://dc0hc3otlytmh.cloudfront.net",
                "http://3.210.31.248:8005",
                "https://expense-prep.happay.in"
            ].indexOf(origin) !== -1
        ) {
            return "6LdL7T8UAAAAAMxVRrPW8hqpAHWMtRCE2TSDSfuO";
        } else if (origin == "https://expense.happay.in") {
            return "6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL";
        } 
            return "6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL";
        
    }
    onChangeCaptcha(value) {
        const { user, code, activeTab } = this.state;
        const temp = {
            ...(activeTab === 1 ? { mobile_number: user } : { email_id: user }),
            mobile_extension: code,
            response: value
        };
        this.setState(
            {
                response: value
            },
            () => this.onSignIn(temp)
        );
    }
    _otpRecieve() {
        let { response } = this.state;
        this.setState({
            OTPSent: LoginStore._getField("otp"),
            showOtpTab: response ? true : false
        });
    }
    renderGoogleCaptcha() {
        return (
            <Recaptcha
                ref={e => (this.recaptchaInstance = e)}
                className="g-recaptcha"
                sitekey={this.state.sitekey}
                onChange={this.onChangeCaptcha.bind(this)}
            />
        );
    }
    onSignIn = value => {
        let { OTPSent, response, userId, code } = this.state;
        let data = {};
        if (!OTPSent) {
            data.mobile_number = value.mobile_number;
            data.email_id = value.email_id;
            data.mobile_extension = code;
            data.response = response;
            LoginAction.sendOTPApi(data);
        } else {
            data.user = value.user;
            data.mobile_extension = value.mobile_extension;
            data.otp = value.otp;
            if (userId) {
                data.user_id = userId;
            }
            LoginAction.loginApi(data, true);
        }
    };

    _handleGoBack = () => {
        this.setState({
            response: "",
            OTPSent: "",
            showOtpTab: false
        });
    };

    render() {
        const { code, user, activeTab, response, OTPSent, showOtpTab } = this.state;
        const { ProductLogo, breakPoints, privacyPolicyUrl, termOfUseUrl } = this.props;

        return (
            <div>
                {OTPSent && response && showOtpTab ? (
                    <SigninPostOTPPage
                        containerClassName={`signin-container ${
                            Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
                        }`}
                        logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                        breakPoints={breakPoints}
                        onSignIn={this.onSignIn}
                        onClickBack={this._handleGoBack}
                        data={{
                            code: code,
                            value: user,
                            activeTab: activeTab
                        }}
                        privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                        termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                        privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
                        termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
                        postOtpHeader={i18n.t("placeholder.enterOtp")}
                        backButtonText={i18n.t("btn.back")}
                        signInButtonText={i18n.t("btn.signIn")}
                        postOtpSubHeaderOne={i18n.t("flexi.yourOtpHasBeenSent")}
                        postOtpSubHeaderTwo={i18n.t("flexi.pleaseEnterSign")}
                        otpFloatingLabelText={i18n.t("lbl.otp")}
                        otpHintText={i18n.t("lbl.enterOTP")}
                        otpValidationStr={i18n.t("err.otpCannotBeEmpty")}
                    />
                ) : (
                    <SigninPreOTPPage
                        containerClassName={`signin-container ${
                            Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
                        }`}
                        logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                        breakPoints={breakPoints}
                        onSignIn={this.onSignIn}
                        onClickBack={() => {
                            history.goBack();
                        }}
                        disableButton={response === "" ? true : false}
                        googleCaptcha={this.renderGoogleCaptcha()}
                        data={{
                            value: user,
                            activeTab: activeTab
                        }}
                        privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                        termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                        privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
                        termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
                        preOtpHeader={i18n.t("logIn.sendOtp")}
                        backButtonText={i18n.t("btn.back")}
                        getOtpButtonText={i18n.t("logIn.getOtp")}
                    />
                )}
            </div>
        );
    }
}
